<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: 'Organizing',
  }
</script>

<style scoped>

</style>
